import { resolveImagePath } from '@/utils/imageResolver';

export function FreshBread() {
  const breadBackground = resolveImagePath('/images/fresh-bread-parallax.jpg');
  const storefrontImage = resolveImagePath('/images/storefront-window-art.jpg');

  return (
    <section className="relative">
      {/* Parallax Hero Section */}
      <div 
        className="relative h-96 bg-cover bg-center bg-fixed flex items-center justify-center"
        style={{ backgroundImage: `url(${breadBackground})` }}
      >
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-black/40"></div>
        
        {/* Content */}
        <div className="relative z-10 text-center text-white">
          <h1 className="text-4xl md:text-6xl font-bold tracking-wider mb-2">
            FRESH BAKED BREAD!
          </h1>
          <p className="text-xl md:text-2xl font-light tracking-wide">
            Every Day
          </p>
        </div>
      </div>

      {/* Content Section Below */}
      <div className="bg-cream-base py-16">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            {/* Left side - Image */}
            <div className="relative">
              <img 
                src={storefrontImage} 
                alt="Diana's Morning Brew Storefront with Eddy the Egg" 
                className="w-full rounded-lg shadow-lg"
              />
            </div>
            
            {/* Right side - Text */}
            <div className="text-center md:text-left">
              <h2 className="text-2xl md:text-3xl font-bold text-coffee-dark mb-6 tracking-wide">
                THANK YOU TO THE COMMUNITY FOR WELCOMING AND SUPPORTING US WITH OPEN ARMS.
              </h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}